import React from 'react';
import { Check } from 'lucide-react';
import { CheckoutButton, Section } from './Shared';
import { OfferCountdown } from './OfferCountdown';
import { offer } from '../data/offer';
import { includedItems } from '../data/landing';
import { useDeadlineCountdown } from '../hooks/useDeadlineCountdown';
export function Pricing() {
  const timeLeft = useDeadlineCountdown(offer.closesAt);
  const showSpots = offer.spotsAvailable !== null;
  return <Section id="oferta" className="max-w-5xl scroll-mt-10" data-id="element-174" data-mp="1vubmalpbab5g">
      <div className="text-center max-w-2xl mx-auto" data-id="element-175" data-mp="1rt8781f38j5a">
        <h2 className="text-[28px] md:text-5xl font-display font-bold leading-tight text-brand-purpleDark" data-id="element-176" data-mp="1ruj7hr9br8rn">
          🌿 Tu biblioteca de fitoterapia, en un solo pack
        </h2>
        <p className="mt-4 text-base md:text-lg text-brand-text" data-id="element-177" data-mp="20rtlhkdj1c09">
          Recursos para consultar información, preparar tu trabajo y registrar
          el seguimiento.
        </p>
      </div>

      <div className="mt-10 rounded-3xl border-2 border-brand-purple bg-white shadow-[0_10px_40px_rgba(23,61,31,0.14)] grid md:grid-cols-2 overflow-hidden" data-id="element-178" data-mp="3c7ry1y7wyg68">
        <div className="p-6 md:p-10 bg-brand-surfaceLight/50" data-id="element-179" data-mp="4smdkodwtzxq">
          <p className="text-xs md:text-sm font-bold tracking-[0.14em] text-brand-goldDark" data-id="element-180" data-mp="4uyuqzbug69q">
            RECIBES:
          </p>
          <ul className="mt-4 space-y-3" data-id="element-181" data-mp="er1yuaq9aezb">
            {includedItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-182" data-mp="3d8yzxlkma9cg">
                <Check className="w-5 h-5 mt-0.5 text-brand-purple shrink-0" strokeWidth={3} data-id="element-183" data-mp="3das9p9qj19oo" />
                <span className="text-base text-brand-text" data-id="element-184" data-mp="3n6llus0c315x">{item}</span>
              </li>)}
          </ul>
          <p className="mt-6 pt-5 border-t border-brand-purple/15 text-sm md:text-base font-medium text-brand-purpleDark" data-id="element-185" data-mp="3rywvimkvm1bo">
            5 volúmenes + 3 bonus · 405 páginas en 8 archivos PDF
          </p>
        </div>

        <div className="p-6 md:p-10 flex flex-col justify-center text-center" data-id="element-186" data-mp="2zfzobunygza6">
          <p className="text-xs md:text-sm font-bold tracking-[0.14em] text-brand-goldDark" data-id="element-187" data-mp="2rftdidf81ngp">
            PRECIO DE LANZAMIENTO
          </p>
          <p className="mt-3 text-lg md:text-xl text-brand-text/45 line-through" data-id="element-188" data-mp="2mfp57aogvz1k">
            {offer.originalPrice}
          </p>
          <p className="font-serif font-bold text-6xl md:text-7xl text-brand-purple mt-1 leading-none" data-id="element-189" data-mp="2w7uycnqggmic">
            {offer.price}
          </p>
          <p className="mt-3 text-sm md:text-base text-brand-muted" data-id="element-190" data-mp="28iiqpsas0mi5">
            Pago único · Sin suscripciones
          </p>

          {timeLeft && <div className="mt-7" data-id="element-191" data-mp="2ifwwmxz2psw7">
              <p className="text-sm font-semibold text-brand-purpleDark mb-3" data-id="element-192" data-mp="2igy7b1c6gdde">
                ⏳ Esta promoción finaliza en:
              </p>
              <OfferCountdown variant="boxes" data-id="element-193" data-mp="2djg6jy8bd4gh" />
            </div>}

          {showSpots && <p className="mt-5 text-sm md:text-base text-brand-text" data-id="element-194" data-mp="3ow8x55pdbmuy">
              Cupos disponibles al precio de lanzamiento:{' '}
              <strong className="text-brand-purple tabular-nums" data-id="element-195" data-mp="a42dnwg2onc">
                {offer.spotsAvailable}
              </strong>
            </p>}

          <CheckoutButton fullWidth className="mt-7" data-id="element-196" data-mp="57409bj54l3d">
            → QUIERO MI MEGAPACK POR {offer.price}
          </CheckoutButton>
        </div>
      </div>
    </Section>;
}